import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import CreateIcon from './create-icon/CreateIcon'

const Container = ({ disabled, children, to }) => {
    return disabled ? (
        <Link
            className="d-flex justify-content-between align-items-center"
            to={to}
            onClick={event => event.preventDefault()}
        >
            {children}
        </Link>
    ) : (
        <Link className="d-flex justify-content-between align-items-center" to={to}>
            {children}
        </Link>
    )
}
Container.propTypes = {
    disabled: PropTypes.bool,
    to: PropTypes.string,
    children: PropTypes.any,
}

const AddButtonAsLink = ({ to, disabled, className, id, label }) => {
    return (
        <Container disabled={disabled} to={to || '#'}>
            <CreateIcon disabled={disabled} className={`material-icons ${className}`} id={id} label={label} />
        </Container>
    )
}

AddButtonAsLink.propTypes = {
    to: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string,
}

export default AddButtonAsLink
